export const ru = {
    direct: 'Директ'
};
